export default __webpack_public_path__ + "static/media/purple_studen_dashboard_bg.a9af7cfc.jpg";